var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitebox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 403,
    viewBox: "0 0 316 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59063C0 1.60759 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V397.016C316 400.321 313.321 403 310.016 403H5.98437C2.67929 403 0 400.321 0 397.016V3.59063Z",
    fill: "#E5E5E5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59064C0 1.6076 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V393.016C316 396.321 313.321 399 310.016 399H5.98437C2.67929 399 0 396.321 0 393.016V3.59064Z",
    fill: "#E5E5E5",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59064C0 1.6076 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V388.016C316 391.321 313.321 394 310.016 394H5.98437C2.67929 394 0 391.321 0 388.016V3.59064Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59064C0 1.60759 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V382.016C316 385.321 313.321 388 310.016 388H5.98437C2.67929 388 0 385.321 0 382.016V3.59064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebox);
export default __webpack_public_path__ + "static/media/whitebox.90eaf45415b002d854ca4fd5aabb06ac.svg";
export { ForwardRef as ReactComponent };